<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <caja-mensual-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import CajaMensualShowData from "./CajaMensualShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "CajaMensualShow",
        components: {CrudShow, CajaMensualShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.cajaMensual.showing',
            }
        },
    }
</script>

